import Hero from './components/Hero';
import About from './components/About';
import Mozambique from './components/Mozambique';
import Dubai from './components/Dubai';
import Rickenbacker from './components/Rickenbacker';
import Hebron from './components/Hebron';
import Products from './components/Products';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <About />
      <Mozambique />
      <Dubai />
      <Rickenbacker />
      <Hebron />
      <Products />
      <Services />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}
